import { render } from "./MandateEmailModal.vue?vue&type=template&id=3fe387f4&scoped=true"
import script from "./MandateEmailModal.vue?vue&type=script&lang=js"
export * from "./MandateEmailModal.vue?vue&type=script&lang=js"

import "./MandateEmailModal.vue?vue&type=style&index=0&id=3fe387f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe387f4"]])

export default __exports__